<div class="precheck-container">
  <div mat-dialog-title class="title">
    <i class="material-icons mdi mdi-bug-check-outline"></i>Precheck
  </div>
  <div *ngIf="!showPrecheckStatus" class="container">
    <mat-dialog-content class="content">
      <div *ngIf="selectedAgent.length === 0">
        <div class="content-description">Select where script will be prechecked</div>
        <div class="agent-selection">
          <div class="agent-link" (click)="selectAgent()">Select agent</div>
        </div>
      </div>
      <div *ngIf="selectedAgent.length">
        <div class="content-description">Select where script will be prechecked</div>
        <div class="agent-selection">
          <div class="agent-name" *ngIf="selectedAgent[0].name">
            {{ selectedAgent[0].name.label }}
          </div>
          <div class="warning-message" *ngIf="selectedAgent[0].isWarningMessage">
            {{ selectedAgent[0].warningMessage }}
          </div>
          <div class="agent-link" (click)="selectAgent()">Change agent</div>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="action">
      <button mat-flat-button (click)="startTest()" [disabled]="checkDisableTest()">
        Start precheck
      </button>
      <button mat-button (click)="closeDialog({ dialogClose: false })">Cancel</button>
    </mat-dialog-actions>
  </div>

  <div *ngIf="showPrecheckStatus" class="container">
    <mat-dialog-content class="content">
      <div class="loader-content">
        <div class="spinner" *ngIf="showProgress">
          <mat-spinner [diameter]="60"></mat-spinner>
        </div>
        <div class="success-icon" *ngIf="!showProgress && !precheckFailed">
          <i class="mdi mdi-check-circle-outline"></i>
        </div>
        <div class="error-icon" *ngIf="!showProgress && precheckFailed">
          <i class="mdi mdi-close-circle-outline"></i>
        </div>
        <div class="loader-text">
          <div class="text-message" *ngIf="scriptStatusMessage">{{ scriptStatusMessage }}</div>
          <div
            class="text-reason"
            [innerHTML]="scriptFailureReason"
            *ngIf="scriptFailureReason"
          ></div>
          <div class="text-reason" *ngIf="showProgress">
            You can wait or close this dialog. <br />We will notify you when your precheck has been
            completed.
          </div>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="action" *ngIf="showProgress">
      <button mat-flat-button (click)="closeDialog({ dialogClose: true })">Close</button>
    </mat-dialog-actions>
    <mat-dialog-actions class="action" *ngIf="!showProgress">
      <button mat-flat-button (click)="closeDialog({ dialogClose: !precheckFailed })">Done</button>
    </mat-dialog-actions>
  </div>
</div>
